import React, { FC, useCallback } from "react";
import { IDamsList, IStateOfKnowledge, dataEntry, IDataTest, ISocietalRisk, ISummaryControlMeasureAdequacy, ISummaryControlMeasureAssessment, ICostSummary, ISummaryCriticalHazards, ISummarySOK, ILikelihood, IHarmSummary } from "../../types/types";
import { Accordion, AccordionSummary, Grid, Paper, Tooltip, IconButton, colors,    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Table } from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import LineChart from "./line_chart";
import ConfidenceChart from "./confidence_chart";
import LineCost from "./line_cost";




interface ISokProps {
    //stateOfKnowledge: IStateOfKnowledge[],
    prioritisationData: any,
    baselineConfidence: any

}


const PrioritisationGraphs: FC<ISokProps> = ({ prioritisationData, baselineConfidence }) => {



    // group the prioritisationData by dam
    const groupedData = prioritisationData.reduce((r : any, a: any) => {
        r[a.dam_id] = [...r[a.dam_id] || [], a];
        return r;
    }, {});

    // for each dam, get min societal_risk_before
    const maxSocietalRiskBefore = Object.keys(groupedData).map((key: any) => {
        return {
            dam_id: key,
            maxSocietalRiskBefore: Math.max(...groupedData[key].map((o: any) => o.societal_risk_before))
        }
    })


    // calculate the sum of the max maxSocietalRiskBefore
    const sumMaxSocietalRiskBefore = maxSocietalRiskBefore.reduce((a: any, b: any) => a + b.maxSocietalRiskBefore, 0)

    // create an array of the cumulative  incremental risk reduction based on the prioritisationData
    const cumulativeIncrementalRiskReduction = prioritisationData.map((entry: any, index: any) => {
        return {
            dam_id: entry.dam_id,
            incremental_risk_reduction: entry["incremental risk reduction"],
            cumulativeIncrementalRiskReduction: prioritisationData.slice(0, index + 1).reduce((a: any, b: any) => a + b["incremental risk reduction"], 0),
            cumulativeCost: prioritisationData.slice(0, index + 1).reduce((a: any, b: any) => a + b["cost"], 0)
        }
    })

    const safetyMargin = 0.001

    const get_aggregate_risk_reduction = (dam_id: number, order: number): number => {
        // aggregate risk reduction for a dam and order
        const filteredData = prioritisationData.filter((entry: any) => entry.dam_id === dam_id && entry.order < order)
        const aggregate_risk_reduction = filteredData.reduce((a: any, b: any) => a + b["incremental risk reduction"], 0)
        return aggregate_risk_reduction
    }



    const cumMargin = prioritisationData.map((pd: any) => {
        const above_saftey = maxSocietalRiskBefore.map((mr: any) => {
            const risk_reduction = get_aggregate_risk_reduction(Number(mr.dam_id), Number(pd.order))
            const risk = mr.maxSocietalRiskBefore - risk_reduction
            if(risk > safetyMargin) {
                return 1
            }
            return 0
        })
        
        // sum of above_saftey
        const sum_above_saftey = above_saftey.reduce((a: any, b: any) => a + b, 0)
        return {
            index: pd.order,
            value: sum_above_saftey
        }
    })



        


    // create data for the line chart

    const cumRisk = cumulativeIncrementalRiskReduction.map(( entry: any, index: number) => {
        return {
            index: index +1,
            name: entry.dam_id,
            value: Math.max(0, sumMaxSocietalRiskBefore - entry.cumulativeIncrementalRiskReduction),
            cost: entry.cumulativeCost
        }
    })

    type SocietalRiskCounter = {
        [key: number]: number;
      };

    
    // count the number of dams in each societal_risk_confidence_id category depending on the number of implemented control measures
    const countSocietalRiskConfidence = (highest_implemented:number):SocietalRiskCounter => {
        // filter the prioritisationData to include control measures that have a smaller or equal implemented_control_measure_id than the highest_implemented
        const filteredData = prioritisationData.filter((entry: any) => entry.order < highest_implemented)
        // count the number of dams in each societal_risk_confidence_id category
        const societal_risk_counter:SocietalRiskCounter = {
            1: 0,
            2: 0,
            3: 0,
            4: 0
        }
        // group the filteredData by dam
        const groupedData = filteredData.reduce((r : any, a: any) => {
            r[a.dam_id] = [...r[a.dam_id] || [], a];
            return r;
        }, {});

        // for each dam, get max societal_confidence_id
        const maxSocietalConfidence = Object.keys(groupedData).map((key: any) => {
            return {
                dam_id: key,
                maxSocietalConfidence: Math.min(...groupedData[key].map((o: any) => o.societal_confidence_id))
            }
        })

        // count the number of dams in each societal_risk_confidence_id category 
        maxSocietalConfidence.forEach((entry: any) => {
            societal_risk_counter[entry.maxSocietalConfidence] += 1
        }
        )

        // add the baseline confidence to the count where no maxSocietalConfidence is available
        baselineConfidence.forEach((entry: any) => {

            // check if dam_id is in maxSocietalConfidence
            const dam_id = entry.dam_id
            
            const dam_id_included = maxSocietalConfidence.some((entry: any) => Number(entry.dam_id) === dam_id)

            if (!dam_id_included) {

                societal_risk_counter[entry.lowestSocietalConfidence] += 1
            }
        })


        return societal_risk_counter


        
    }

    // create data for the confidence chart for each implemented_control_measure_id
    const confidenceChartData = Object.keys(prioritisationData).map((key: any) => {
        return {
            index: key,
            values: countSocietalRiskConfidence(key)
        }   
    })


    return (
        <>
            <Accordion expanded={true}>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore /> }>
                    <Typography variant="h6"> Prioritisation </Typography>
                </AccordionSummary>
              <>
              <LineChart data={{data: cumRisk, title: "Portfolio Risk", yAxisName: "Societal Risk"}} />
              <LineChart data={{data: cumMargin,  title: "Dams Above Saftey Threshold", yAxisName: "Number of Dams"}} />
              <ConfidenceChart data={{data: confidenceChartData}} />
              <LineCost data={ {data: cumRisk}} />
              </>
            </Accordion>

        </>
    )
}


export default PrioritisationGraphs;
